import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../../components/components.module';
import { WalletHomePage } from './wallet-home';

@NgModule({
  declarations: [
    WalletHomePage,
  ],
  imports: [
    IonicPageModule.forChild(WalletHomePage),
    CommonModule,
    ComponentsModule,
  ],
})
export class WalletHomePageModule { }



// WEBPACK FOOTER //
// ./src/pages/wallet-home/wallet-home.module.ts